import React, { Component } from 'react';
import { themr } from 'react-css-themr';
import { translate } from 'react-i18next';
import compose from 'recompose/compose';
import * as Immutable from 'immutable';
import theme from './TeamSelectorFilter.scss';

import { teamsSelector } from 'common/redux/selectors/teamSelector';
import { withRouter } from 'common/components/core/router';
import { connect } from 'react-redux';
import ArrayUtil from 'common/utils/ArrayUtil';
import { MultiSelectFilter, SelectTypes } from 'common/components/core/select';
import { TeamStatusEnum } from 'common/enums/TeamEnum';

const selectTeamName = option => option.name;
const selectTeamId = option => option.teamId;

class TeamFilter extends Component {
    static defaultProps = {
        getOptionLabel: selectTeamName
    };

    clearTeam = () => {
        this.props.onChange(null);
    };

    onTeamOptionClick = ({ values, allowEmptyOrNull }) => {
        // adding logic for multiselect and special handling for (BLANKS) case.
        const { onChange } = this.props;
        const idList = values.map(selectTeamId).filter(teamId => teamId);
        // filter because MultiSelectFilter returns group label along with values
        // on clear selection
        if (!idList.length && !allowEmptyOrNull) {
            onChange();
            return;
        }

        onChange({ values: idList, allowEmptyOrNull });
    };

    getTeamsList = teams => {
        const allTeamsList = ArrayUtil.sortByKey(teams.toList(), 'name');
        const { theme, t } = this.props;
        const { activeTeams, inActiveTeams } = allTeamsList.reduce(
            ({ activeTeams, inActiveTeams }, current) => {
                if (current.status === TeamStatusEnum.Active) {
                    return {
                        activeTeams: [...activeTeams, current],
                        inActiveTeams
                    };
                }
                return {
                    activeTeams,
                    inActiveTeams: [...inActiveTeams, current]
                };
            },
            { activeTeams: [], inActiveTeams: [] }
        );
        if (inActiveTeams.length) {
            inActiveTeams.unshift({
                label: t('inactiveTeams'),
                isGroupTitle: true,
                className: theme.teamSeparator
            });
        }
        return Immutable.fromJS([...activeTeams, ...inActiveTeams]);
    };

    getOptionClassName = data => {
        const { theme } = this.props;
        if (data.status === TeamStatusEnum.Inactive) {
            return theme.inactiveOption;
        }
    };

    render() {
        const { theme, className, teams, value, ...rest } = this.props;

        const teamsList = this.getTeamsList(teams);
        const disabled = !teamsList.size;
        return (
            <MultiSelectFilter
                {...rest}
                theme={theme}
                disabled={disabled}
                className={className}
                selectType={SelectTypes.Outline}
                options={teamsList.toJS()}
                value={value?.values || ''}
                allowEmptyOrNull={value?.allowEmptyOrNull || false}
                onChange={this.onTeamOptionClick}
                getOptionClassName={this.getOptionClassName}
                getOptionValue={selectTeamId}
            />
        );
    }
}

const ThemedTeamSelectorFilter = compose(
    themr('TeamFilter', theme),
    translate()
)(TeamFilter);

const ConnectedTeamSelectorFilter = withRouter(
    connect((state, ownProps) => {
        const teams = teamsSelector(state, ownProps);

        return {
            teams
        };
    })(ThemedTeamSelectorFilter)
);

const ConnectedTeamIdSelectorFilter = props => (
    <ConnectedTeamSelectorFilter {...props} getOptionLabel={selectTeamId} />
);

export default ThemedTeamSelectorFilter;
export { ConnectedTeamSelectorFilter, ConnectedTeamIdSelectorFilter };
